// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"fbb76ab8","90":"85f86e43","615":"67803ece","789":"e0a2391c","791":"d7e5777e","912":"f8c25384","930":"06eb8c5c"}[chunkId] + ".chunk.js";
};